import { useState } from 'react';
import { Button, Dialog, TextField, useToast } from '@dugzi/ui';
import { api } from '../lib/api';
import { useData } from '../lib/data';
import type { Book } from '../lib/types';

export function RenameBook({ book, onClose }: { book: Book; onClose(): void }) {
  const { reload } = useData();
  const toast = useToast();
  const [name, setName] = useState(book.name);
  const [error, setError] = useState<string | null>(null);
  const save = async () => {
    try { await api(`/api/books/${book.id}`, { method: 'PATCH', body: { name } }); await reload(); toast.show('Renamed.'); onClose(); } catch (e) { setError((e as Error).message); }
  };
  return (
    <Dialog open onClose={onClose} title={`Rename ${book.name}`} actions={<><Button variant="ghost" onClick={onClose}>Cancel</Button><Button variant="primary" onClick={save}>Save</Button></>}>
      <form onSubmit={(e) => { e.preventDefault(); save(); }}><TextField label="Name" value={name} onChange={(e) => setName(e.target.value)} error={error ?? undefined} autoFocus /></form>
    </Dialog>
  );
}
